import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    code: Yup.string().required('Campul este obligatoriu.'),
    name: Yup.string()
      .test('notOnlySpaces', 'Campul trebuie sa contina caractere.', value => {
        return /\S/.test(value)
      })
      .required('Campul este obligatoriu.'),
    active: Yup.boolean().required('Campul este obligatoriu.'),
    returnable: Yup.boolean().required('Campul este obligatoriu.'),
    childrenIds: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string(),
          label: Yup.string()
        })
      )
      .nullable()
  })

export const getInitialValues = (editItem: PackingType) => {
  return {
    code: editItem?.code || '',
    name: editItem?.name || null,
    active: editItem?.active || false,
    returnable: editItem?.returnable || false,
    childrenIds: editItem?.childrenIds || []
  }
}
